module.exports = __webpack_public_path__ + "ge.782bbcba01113888253d.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/ge.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/ge.svg
// module chunks = styles